import type { KPIRequest } from "@/types/kpiTypes.ts"

export const PEPLKPIs: KPIRequest[] = [
  {
    $type: "calc",
    name: "Raw Inlet Gas per Minute",
    unit: "SCFM",
    expression: "[60] / 1.44",
    aggFunction: "Average",
    location: 6,
  },
  {
    $type: "basic",
    id: 60,
    location: 6,
  },
  {
    $type: "basic",
    id: 65,
    location: 6,
    padding: 32,
  },
  {
    $type: "basic",
    id: 61,
    location: 6,
  },
  {
    $type: "calc",
    name: "Max kWh",
    unit: "kWh",
    aggFunction: "Sum",
    location: 6,
    expression: "[61]/225*800*24",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Efficiency",
    unit: "%",
    aggFunction: "Average",
    location: 6,
    expression: "100 * [260]/([61]/225*800*24)",
    padding: 32,
  },
  { $type: "basic", id: 260, location: 6 },
  {
    $type: "calc",
    name: "Average Power",
    unit: "kW",
    aggFunction: "Average",
    location: 6,
    expression: "[260]/24",
    padding: 32,
  },
  { $type: "basic", id: 265, location: 6 },
  {
    $type: "calc",
    name: "Average Power Utility",
    unit: "kW",
    aggFunction: "Average",
    location: 6,
    expression: "[265]/24",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Generator Productive Output",
    unit: "#",
    aggFunction: "Average",
    location: 6,
    expression: "[260]/24/800",
  },
  {
    $type: "basic",
    id: 270,
    location: 6,
  },
]
